<app-uni-page [parent]="this" pageTitle="In-Process: Staging / Vouchering" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate">
</app-uni-page>

<ng-template #bodyTemplate>
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[35, 30, 35]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-panel-title mx-4 my-2 shrink-0">Ship Bins</div>
        <app-ag-grid [gridOptions]="binGridOptions" [rowData]="shipBins" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="flex justify-between items-center mx-4 my-2 shrink-0">
          <div class="qb-panel-title m-0">
            Bin Contents
            <span *ngIf="selectedShipBin"> — Bin {{ selectedShipBin.id }}</span>
          </div>
        </div>
        <app-ag-grid [gridOptions]="detailGridOptions" [rowData]="binItemDetails" class="flex-1 min-h-0"></app-ag-grid>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full overflow-hidden">
        <div class="qb-panel-title mx-4 my-2 shrink-0">
          JO Status
          <span *ngIf="selectedJoHeaderId"> — JO {{ selectedJoHeaderId }}</span>
        </div>
        <p-tabView class="flex-1 min-h-0 uni-tabview">
          <p-tabPanel header="In-Process ({{ inProcessItems.length }})">
            <app-ag-grid [gridOptions]="inProcessGridOptions" [rowData]="inProcessItems" class="h-full"></app-ag-grid>
          </p-tabPanel>
          <p-tabPanel header="Back Ordered ({{ backorderItems.length }})">
            <app-ag-grid [gridOptions]="backorderGridOptions" [rowData]="backorderItems" class="h-full"></app-ag-grid>
          </p-tabPanel>
        </p-tabView>
      </div>
    </ng-template>
  </p-splitter>
</ng-template>

<ng-template #footerTemplate>
  <div class="left-buttons">
    <button pButton type="button" class="p-button-raised" icon="pi pi-arrow-left" (click)="goBack()">
      <span>Go Back</span>
    </button>
  </div>
</ng-template>
